// Named hooks: lets the legacy collections.js (bundled into the client too) call server-only code of the new modules
// without importing it. A server module registers the function at startup; on the client nothing is registered and
// runHook returns undefined, so the caller keeps its legacy behaviour.
import { Meteor } from 'meteor/meteor';
var hooks = {};
export var setHook = function setHook(name, fn) {
  hooks[name] = fn;
};
export var runHook = function runHook(name) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (hooks[name]) return hooks[name].apply(hooks, args); // on the server every hook is registered at startup: a missing one is a typo or a dropped import, which would
  // otherwise switch the server code off without a word (#525)

  if (Meteor.isServer) console.warn('runHook: no hook registered as ' + name);
  return undefined;
};